import { useMutation, useQuery } from 'react-query';
import { getApplicationRequestDetails } from '../../../api/applicationRegistration';
import { DismissalJointLiabilityMutationApplication } from '__generated__/api';
import { AxiosResponse } from 'axios';
import { saveOhaMutation } from 'api/oha';

export function useMutateApplication(
  onSuccess: (data: AxiosResponse<DismissalJointLiabilityMutationApplication>) => void,
  onError: (error: any) => void
) {
  return useMutation(saveOhaMutation(), {
    onSuccess,
    onError,
  });
}

export function useGetApplication(id = 0) {
  return useQuery(['get-application-request-details'], () => getApplicationRequestDetails(id), {
    enabled: false,
  });
}
